const BookingForm = () => {
  return  (
    <div className="w-full bg-white border border-gray-200 shadow-md rounded-xl p-4 text-gray-800 space-y-4 text-[13px]">
      <h2 className="text-base font-semibold text-gray-800">✈️ Travel Booking Form</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Full Name</label>
          <input
            type="text"
            placeholder="John Doe"
            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
          />
        </div>

        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Email</label>
          <input
            type="email"
            placeholder="john@example.com"
            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
          />
        </div>

        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Departure City</label>
          <input
            type="text"
            placeholder="New York"
            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
          />
        </div>

        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Destination City</label>
          <input
            type="text"
            placeholder="Paris"
            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
          />
        </div>

        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Departure Date</label>
          <input
            type="date"
            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
          />
        </div>

        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Return Date</label>
          <input
            type="date"
            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
          />
        </div>

        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Travelers</label>
          <input
            type="number"
            min="1"
            placeholder="2"
            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
          />
        </div>

        <div>
          <label className="block text-[12px] text-gray-600 mb-1">Class</label>
          <select className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500">
            <option>Economy</option>
            <option>Business</option>
            <option>First Class</option>
          </select>
        </div>
      </div>

      <div>
        <label className="block text-[12px] text-gray-600 mb-1">Special Requests</label>
        <textarea
          rows={3}
          placeholder="Any notes or requests..."
          className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[13px] focus:outline-indigo-500"
        ></textarea>
      </div>

      <div className="text-right">
        <button className="bg-indigo-600 hover:bg-indigo-700 text-white text-[13px] font-medium px-4 py-1.5 rounded-md transition">
          Submit Booking
        </button>
      </div>
    </div>
  );
};
export default BookingForm;